import React from 'react'
import PropTypes from 'prop-types'

const TitleMarkField = ({ mark, first }) => (
  <div className={first ? '' : 'tw:pt-15'}>
    <div className="tw:text-base tw:font-medium tw:text-gray-900">{mark.question.title}</div>
  </div>
)

TitleMarkField.propTypes = {
  first: PropTypes.bool,
  mark: PropTypes.shape({
    question: PropTypes.shape({
      title: PropTypes.string
    })
  }).isRequired
}

TitleMarkField.defaultProps = {
  first: false
}

export default TitleMarkField
